export const motorcycleParamsInitialData = {
  Make: '',
  Year: '',
  Model: '',
  modelId: '',
};
